import React, { useState, useEffect } from 'react'
import { fetchStoresSortedByDistance } from 'base/lib/localization'
import Link from 'base/react/components/link'

export default function StoresFooter() {
  const [closestStore, setClosestStore] = useState([])

  useEffect(() => {
    async function getClosestStore() {
      const closestStore = await fetchStoresSortedByDistance({ limit: 1 })

      setClosestStore(closestStore)
    }
    getClosestStore()
  }, [])

  return closestStore?.distanceFromUser ? (
    <Link href="/stores">
      {`Your nearest store location is ${Math.round(
        (10 * closestStore.distanceFromUser) / 10,
      )} mi away`}
      <br />
      {`in ${closestStore.city}. `}
      <b>See Our Stores</b>
    </Link>
  ) : (
    <Link href="/stores">
      Find a location nearest <br /> you. <span className="underline">See Our Stores</span>
    </Link>
  )
}
